import {
  Counter, StartGameBtn, Score, TopBar, CurrentPlayers, SwapTeamBtn, BalanceTeamsBtn,
  SwapPlayersBtn, ExplainingIcons, CheckoutAllPlayers,
} from 'components';
import { Box, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { removeAllPlayersFromTeams, removeAllPlayersFromTeamBoard, resetAllStayIn } from 'redux/slices';

export function Scoreboard() {
  const dispatch = useDispatch();

  const handleResetTeams = () => {
    dispatch(removeAllPlayersFromTeams());
    dispatch(removeAllPlayersFromTeamBoard());
  };

  return (
    <Box>
      <TopBar />
      <Score />
      <Counter />
      <StartGameBtn />
      <CurrentPlayers />
      <SwapTeamBtn />
      <SwapPlayersBtn />
      <BalanceTeamsBtn />
      <Box sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, my: 2,
      }}
      >
        <CheckoutAllPlayers fullWidth={false} />
        <Button variant="contained" color="secondary" onClick={handleResetTeams}>
          Resetar Times
        </Button>
        <Button variant="outlined" color="warning" onClick={() => dispatch(resetAllStayIn())}>
          Resetar Stay In
        </Button>
      </Box>
      <ExplainingIcons />
    </Box>
  );
}
